import { a as _toConsumableArray } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext } from 'react';
import '@apollo/client';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { useResponsiveParams, Text, Modal, DataGridGroup } from 'quanta-ui';
import { P as Parse } from './CurrencyFormater-d288bc4f.js';

function ModalViewBreakup(_ref) {
  var _reactive_var_plan$pl, _reactive_var_plan$pl2, _breakupData$cover, _breakupData$cover2, _reactive_var_quote$c, _breakupData$cover3, _breakupData$cover4, _reactive_var_quote$c2, _breakupData$cover5, _breakupData$cover6, _reactive_var_quote$c3, _selectedPlan$premium, _selectedPlan$premium2;

  var showViewBreakup = _ref.showViewBreakup,
      setShowViewBreakup = _ref.setShowViewBreakup,
      selectedPlanTypeView = _ref.selectedPlanTypeView,
      productName = _ref.productName;
      _ref.productCode;
      _ref.planName;
      _ref.planCode;
      _ref.renewalMode;
      _ref.lobCode;
      _ref.lobName;
      _ref.quoteNumber;
      _ref.proposalNumber;
      var breakupData = _ref.breakupData,
      genderList = _ref.genderList,
      reactive_var_quote = _ref.reactive_var_quote,
      reactive_var_plan = _ref.reactive_var_plan,
      title = _ref.title;
  var repeatForMobile = 2;
  var repeatForDesktop = 3;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding;

  var selectedPlan = reactive_var_plan !== null && reactive_var_plan !== void 0 && (_reactive_var_plan$pl = reactive_var_plan.plans) !== null && _reactive_var_plan$pl !== void 0 && _reactive_var_plan$pl.find(function (plan) {
    return plan.name === selectedPlanTypeView;
  }) ? reactive_var_plan === null || reactive_var_plan === void 0 ? void 0 : (_reactive_var_plan$pl2 = reactive_var_plan.plans) === null || _reactive_var_plan$pl2 === void 0 ? void 0 : _reactive_var_plan$pl2.find(function (plan) {
    return plan.name === selectedPlanTypeView;
  }) : reactive_var_plan;

  var resolveGender = function resolveGender(code) {
    var _genderList$find;

    return (_genderList$find = genderList.find(function (gender) {
      return gender.code.toLowerCase() === code.toLowerCase();
    })) === null || _genderList$find === void 0 ? void 0 : _genderList$find.value;
  };

  var display_data = [{
    grid_data: [{
      colSpan: repeat,
      text: /*#__PURE__*/React.createElement(Text, {
        type: "subheading",
        severity: "info"
      }, productName, ", ", selectedPlanTypeView)
    }]
  }, {
    grid_data: [{
      label: 'Cover Type',
      text: /*#__PURE__*/React.createElement(Text, null, [breakupData !== null && breakupData !== void 0 && (_breakupData$cover = breakupData.cover) !== null && _breakupData$cover !== void 0 && _breakupData$cover.type ? breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$cover2 = breakupData.cover) === null || _breakupData$cover2 === void 0 ? void 0 : _breakupData$cover2.type : reactive_var_quote ? reactive_var_quote === null || reactive_var_quote === void 0 ? void 0 : (_reactive_var_quote$c = reactive_var_quote.cover) === null || _reactive_var_quote$c === void 0 ? void 0 : _reactive_var_quote$c.type : ''])
    }, {
      label: 'Sum Insured',
      text: /*#__PURE__*/React.createElement(Text, null, [breakupData !== null && breakupData !== void 0 && (_breakupData$cover3 = breakupData.cover) !== null && _breakupData$cover3 !== void 0 && _breakupData$cover3.sum_insured ? Parse(breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$cover4 = breakupData.cover) === null || _breakupData$cover4 === void 0 ? void 0 : _breakupData$cover4.sum_insured) : reactive_var_quote ? Parse(reactive_var_quote === null || reactive_var_quote === void 0 ? void 0 : (_reactive_var_quote$c2 = reactive_var_quote.cover) === null || _reactive_var_quote$c2 === void 0 ? void 0 : _reactive_var_quote$c2.sum_insured) : ''])
    }, {
      label: 'Tenure',
      text: /*#__PURE__*/React.createElement(Text, null, [breakupData !== null && breakupData !== void 0 && (_breakupData$cover5 = breakupData.cover) !== null && _breakupData$cover5 !== void 0 && _breakupData$cover5.tenure ? breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$cover6 = breakupData.cover) === null || _breakupData$cover6 === void 0 ? void 0 : _breakupData$cover6.tenure : reactive_var_quote ? reactive_var_quote === null || reactive_var_quote === void 0 ? void 0 : (_reactive_var_quote$c3 = reactive_var_quote.cover) === null || _reactive_var_quote$c3 === void 0 ? void 0 : _reactive_var_quote$c3.tenure : ''])
    }]
  }, {
    grid_data: selectedPlan && selectedPlan.premium ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Members"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Premium (", branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(selectedPlan.premium.breakup.map(function (mem, idx) {
      return [{
        //SARN0031
        text: // (mem.premium!='0.00')
        "".concat(mem.relationship, ", ").concat(resolveGender(mem.gender), ", ").concat(mem.age),
        // :null,
        //EARN0031
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text:
        /*#__PURE__*/
        //SARN0031
        // (mem.premium!='0.00')?
        React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(mem.premium, false)) // :null
        //EARN0031
        ,
        colSpan: 1,
        type: 'normal'
      }];
    }).reduce(function (b, a) {
      return [].concat(_toConsumableArray(b), _toConsumableArray(a));
    })), [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, repeat === repeatForMobile ? 'Base Premium' : 'Total Base Premium'),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(selectedPlan && selectedPlan.premium ? selectedPlan.premium.basePremium : 0, false)),
      severity: 'info',
      colSpan: 1
    }]) : [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "title"
      }, "Members"),
      colSpan: repeat === repeatForMobile ? 1 : 2,
      severity: 'info'
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "title"
      }, "Premium"),
      colSpan: 1,
      severity: 'info'
    }]
  }, {
    grid_data: selectedPlan && selectedPlan.premium && selectedPlan.premium.loading.length > 0 ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Loadings"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Amount (", branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(selectedPlan.premium.loading.map(function (loading, idx) {
      return [{
        text: "".concat(loading.name),
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text: /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(loading.amount, false)),
        colSpan: 1,
        type: 'normal'
      }];
    }).reduce(function (b, a) {
      return [].concat(_toConsumableArray(b), _toConsumableArray(a));
    }))) : [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Loading"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(0, false)),
      severity: 'info',
      colSpan: 1
    }]
  }, {
    grid_data: selectedPlan && selectedPlan.premium && ((_selectedPlan$premium = selectedPlan.premium) === null || _selectedPlan$premium === void 0 ? void 0 : (_selectedPlan$premium2 = _selectedPlan$premium.discount) === null || _selectedPlan$premium2 === void 0 ? void 0 : _selectedPlan$premium2.length) > 0 ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Discounts"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Amount (", branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(selectedPlan.premium.discount.map(function (discount, idx) {
      return [{
        text: "".concat(discount.name),
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text: /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(discount.amount, false)),
        colSpan: 1,
        type: 'normal'
      }];
    }).reduce(function (b, a) {
      return [].concat(_toConsumableArray(b), _toConsumableArray(a));
    }))) : [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Discount"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(0, false)),
      severity: 'info',
      colSpan: 1
    }]
  }, {
    grid_data: [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Net Premium"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(selectedPlan && selectedPlan.premium ? selectedPlan.premium.netPremium : 0, false)),
      severity: 'info',
      colSpan: 1
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "GST/Tax"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(selectedPlan && selectedPlan.premium ? selectedPlan.premium.gst : 0, false)),
      severity: 'info',
      colSpan: 1
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "subheading"
      }, "Total Premium"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "subheading",
        className: "flex justify-end mr-4"
      }, Parse(selectedPlan && selectedPlan.premium ? selectedPlan.premium.totalPremium : 0, false)),
      severity: 'info',
      colSpan: 1
    }]
  }];
  return selectedPlan ? /*#__PURE__*/React.createElement("div", {
    className: "text-black font-normal"
  }, /*#__PURE__*/React.createElement(Modal, {
    display: showViewBreakup,
    size: repeat === repeatForMobile ? 'full' : 'small',
    className: repeat === repeatForMobile ? 'h-screen flex flex-col' : '',
    title: title,
    onClose: function onClose(e) {
      return setShowViewBreakup(false);
    }
  }, /*#__PURE__*/React.createElement(DataGridGroup, {
    data: display_data,
    textType: "normal",
    severity: "none",
    repeat: repeat,
    spaceY: 4
  }))) : /*#__PURE__*/React.createElement("div", null);
}

export { ModalViewBreakup as M };
